<template>
  <v-tabs
    v-model="tab"
    centered
    icons-and-text
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab href="#tab-2">
      Calendário
      <v-icon>mdi-calendar</v-icon>
    </v-tab>

    <v-tabs-items v-model="tab">

      <v-tab-item value="tab-2">
        <div class="col">
          <v-row>
            <v-col cols="12">
              <v-row>
                <!-- <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="eventTypes"
                    label="Tipos de eventos"
                    :items="eventTypesList"
                    item-value="value"
                    item-text="text"
                    clearable
                    @click:clear="eventTypes = []"
                    @change="getEvents"
                    :loading="calendarLoading"
                    multiple
                    chips
                    dense
                    deletable-chips
                  />
                </v-col> -->

                <v-col cols="12" sm="12">
                  <AgendaNew
                  :readTitle="'Novo compromisso'"
                  :readOnly=false
                  :isTextButton="true"
                  modelNameSingular="Compromisso"
                  />
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="employeeIds"
                    label="Funcionários"
                    :items="employeesList"
                    item-value="id"
                    item-text="name"
                    clearable
                    @click:clear="employeeIds = []"
                    @change="getEvents"
                    :loading="calendarLoading"
                    multiple
                    chips
                    dense
                    deletable-chips
                    placeholder="Se nenhum funcionário for selecionado, todos são considerados"
                  />
                </v-col> -->
              </v-row>

              <div id="calendarReportPrintTable">
                <!-- <v-sheet
                  tile
                  height="54"
                  class="d-flex"
                > -->
                  <v-row
                    tile
                    height="54"
                    class="d-flex"
                  >
                    <v-col cols="12" md="6">
                      <v-btn
                        icon
                        class="ma-2"
                        @click="$refs.calendar.prev()"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>

                      <v-btn
                        icon
                        class="ma-2"
                        @click="$refs.calendar.next()"
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>

                      <v-toolbar-title class="d-inline mt-2" v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                      </v-toolbar-title>

                    </v-col>
                    
                    <v-col cols="6" md="3">

                      <v-autocomplete
                        v-model="type"
                        :items="types"
                        label="Tipo do calendário"
                        :loading="calendarLoading"
                        class="mx-6"
                        @change="changeCalendarType"
                      ></v-autocomplete>

                    </v-col> 

                    <v-col cols="6" md="3">

                      <DateField
                        :inputData.sync="calendarMonthFilter"
                        :label="type == 'month' ? 'Mês' : 'Dia'"
                        :hasTodayButton="true"
                        :hasTodayDate="true"
                        :pickerType="type == 'month' ? 'month' : 'date'"
                        @change="calendarMonthFilterChanged" 
                        :key="calendarMonthFilterKey"
                      />

                    </v-col>
                  </v-row>
                <!-- </v-sheet> -->

                <!-- <v-sheet > -->
                <v-row>
                  <v-col cols="12">
                  <v-calendar
                    ref="calendar"
                    class="fill-height mt-3"
                    v-model="calendar"
                    :weekdays="weekday"
                    :type="type"
                    :events="events"
                    :event-overlap-mode="mode"
                    :event-overlap-threshold="30"
                    :event-color="getEventColor"
                    @change="getEvents"
                    locale="pt-br"
                    @input="updateMonthFilter"
                    @click:date="changeCalendar"
                    style="font-size: 14px; min-height: 600px"
                  >
                    <template v-slot:event="data">
                      <v-tooltip top :color="data.event.color">
                        <template v-slot:activator="{ on, attrs }">

                          <span>
                            <PurchaseEdit
                              v-if="data.event.parentType == 'Purchase'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Compra'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Compra"
                            />
                            <SaleEdit
                              v-else-if="data.event.parentType == 'Sale'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Venda'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Venda"
                            />
                            <ServiceProvisionEdit
                              v-else-if="data.event.parentType == 'ServiceProvision'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Serviço'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Serviço"
                            />
                            <CashInflowEdit
                              v-else-if="data.event.parentType == 'CashInflow'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Conta a Receber'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Conta a Receber"
                            />
                            <CashOutflowEdit
                              v-else-if="data.event.parentType == 'CashOutflow'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Conta a Pagar'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Conta a Pagar"
                            />
                            <DepositEdit
                              v-else-if="data.event.parentType == 'Deposit'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Depósito'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Depósito"
                            />
                            <TransferEdit
                              v-else-if="data.event.parentType == 'Transfer'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Transferência'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Transferência"
                            />
                            <WithdrawEdit
                              v-else-if="data.event.parentType == 'Withdraw'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Saque'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Saque"
                            />
                            <ExecutionOperationEdit
                              v-else-if="data.event.parentType == 'ExecutionOperation'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Operação Realizada'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Operação Realizada"
                            />
                            <PlanningEdit
                              v-else-if="data.event.parentType == 'Planning'"
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Planejamento'"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Planejamento"
                            />

                             <AgendaEdit
                              :entry="data.event.parentObject"
                              :readTitle="'Visualizar Agenda'- data.event.parentType"
                              :readOnly="true"
                              :isTextButton="false"
                              modelNameSingular="Agenda"
                            />
                            
                            <span v-bind="attrs" v-on="on">
                              <b class="mr-1" v-if="data.eventParsed.start.time">{{data.eventParsed.start.time}}</b> 
                              {{data.event.name}} - {{ data.event.parentType }}
                            </span>
                          </span>
                        </template>
                        <span class="ml-1">
                          <b class="mr-1" v-if="data.eventParsed.start.time">{{data.eventParsed.start.time}}</b> 
                          {{data.event.name}}
                        </span>
                      </v-tooltip>
                    </template>
                  </v-calendar>
                <!-- </v-sheet> -->
                  </v-col>
                </v-row>
              </div>

              <div>
                <BasePrint
                  printableElementId="calendarReportPrintTable"
                  printButtonLabel="Imprimir"
                  printTitle="Calendário"
                  @start-printing="printing = loading = true"
                  @stop-printing="printing = loading = false"
                  class="mt-3"
                />
              </div>
            </v-col>
          </v-row>

        </div>
      </v-tab-item>

    </v-tabs-items>

  </v-tabs>
</template>

<script>
import LineBarChart from "@components/shared/charts/LineBarChart.js";
import DateField from "@shared_components/date_field.vue";
import BasePrint from "@shared_components/base_print.vue";
import moment from "moment";
import gql from 'graphql-tag';
import PurchaseEdit from "@models/purchases/edit.vue";
import SaleEdit from "@models/sales/edit.vue";
import ServiceProvisionEdit from "@models/services_provision/edit.vue";
import CashInflowEdit from "@models/cash_flows/cash_inflows/edit.vue";
import CashOutflowEdit from "@models/cash_flows/cash_outflows/edit.vue";
import DepositEdit from "@models/bank_accounts/bank_account_operations/deposits/edit.vue";
import TransferEdit from "@models/bank_accounts/bank_account_operations/transfers/edit.vue";
import WithdrawEdit from "@models/bank_accounts/bank_account_operations/withdraws/edit.vue";
import CashOutflowInstallmentEdit from "@models/installments/cash_outflow_installments/edit.vue";
import CashInflowInstallmentEdit from "@models/installments/cash_inflow_installments/edit.vue";
import ExecutionOperationEdit from "@models/operations/execution_operations/edit.vue";
import PlanningEdit from "@models/operations/planning_operations/edit.vue";
import AgendaEdit from "@models/agendas/edit.vue";
import AgendaNew from "@models/agendas/new.vue";


export default {
  components: {
    DateField: DateField,
    BasePrint: BasePrint,
    PurchaseEdit: PurchaseEdit,
    SaleEdit: SaleEdit,
    ServiceProvisionEdit: ServiceProvisionEdit,
    CashInflowEdit: CashInflowEdit,
    CashOutflowEdit: CashOutflowEdit,
    DepositEdit: DepositEdit,
    TransferEdit: TransferEdit,
    WithdrawEdit: WithdrawEdit,
    CashOutflowInstallmentEdit: CashOutflowInstallmentEdit,
    CashInflowInstallmentEdit: CashInflowInstallmentEdit,
    ExecutionOperationEdit: ExecutionOperationEdit,
    PlanningEdit: PlanningEdit,
    AgendaEdit: AgendaEdit,
    AgendaNew: AgendaNew,
    LineBarChart
  },
  data () {
    return {
      tab: null,
      cashBookDashboardLoading: true,
      barChartData: {},
      calendarMonthFilter: moment().format('YYYY-MM'),
      monthFilter: moment().format('YYYY-MM'),
      todayDate: moment().format('YYYY-MM-DD'),
      options: {},
      financialIndicators: {},
      type: 'month',
      types: [
        {text: 'Mês', value: 'month'}, 
        {text: 'Semana', value: 'week'}, 
        {text: 'Dia', value: 'day'}, 
        {text: '4 dias', value: '4day'}
      ],
      eventTypesList: [
        {text: 'Operações Bancárias', value: 'bank_account_operations'}, 
        {text: 'Parcelas Pagas/Recebidas', value: 'billed_installments'}, 
        {text: 'Parcelas a Pagar/Receber', value: 'open_installments'}, 
        {text: 'Atividades de Operações Realizadas', value: 'execution_activities'},
        {text: 'Atividades de Operações Planejadas', value: 'planning_activities'},
        {text: 'Atividades de Serviços', value: 'services_provision_activities'},
      ],
      eventTypes: ['bank_account_operations', 'billed_installments', 'open_installments', 'execution_activities', 'planning_activities', 'services_provision_activities'],
      calendarLoading: false,
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      calendar: '',
      events: [],
      employeesList: [],
      employeeIds: [],
      startDate: null,
      endDate: null,
      calendarMonthFilterKey: 1
    }
  },
  created(){
    this.fetchCashBookDashboard();
  },
  watch: {
    // chartLabels () {
    //   this.$data._chart.update()
    // }
  },
  methods: {
    randomPositiveScalingFactor: function() {
      return Math.round(_.random(0, 10, true));
    },
    randomNegativeScalingFactor: function() {
      return Math.round(_.random(-10, 0, true));
    },
    randomScalingFactor: function() {
      return Math.round(_.random(-10, 10, true));
    },
    monthFilterChanged: function() {
      this.fetchCashBookDashboard();
    },
    fetchCashBookDashboard: function() {
      // periodId = periodId.id
      this.productionCostReport = null;
      this.cashBookDashboardLoading = true;
      // console.log(this.monthFilter, this.todayDate)
      this.$apollo
        .query({
          query: CASH_BOOK_DASHBOARD_QUERY,
          variables: {
            monthFilter: this.monthFilter + "-01",
            currentDate: this.todayDate
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          let cashBookDashboard = response.data.accountContext.cashBookDashboard;
          this.$set(this.financialIndicators, 'bankAccountBalance', response.data.accountContext.financialIndicatorBankAccountBalance);
          this.$set(this.financialIndicators, 'storageTotalBalance', response.data.accountContext.financialIndicatorStorageTotalBalance);
          this.$set(this.financialIndicators, 'patrimoniesTotalPrice', response.data.accountContext.financialIndicatorPatrimoniesTotalPrice);
          this.$set(this.financialIndicators, 'ownedAreasTotalPrice', response.data.accountContext.financialIndicatorOwnedAreasTotalPrice);
          // this.balances = cashBookDashboard.balances;
          // this.cashInflowValues = cashBookDashboard.cashInflowValues;
          // this.cashOutflowValues = cashBookDashboard.cashOutflowValues;
          // this.chartLabels = cashBookDashboard.chartLabels;
          // console.log(cashBookDashboard);

          this.barChartData = {
            labels: cashBookDashboard.chartLabels,
            datasets: [
              {
                type: 'line',
                label: 'Saldo Atual',
                borderColor: 'black',
                borderWidth: 2,
                fill: false,
                data: cashBookDashboard.balances,
              }, 
              {
                label: 'Parcelas Pagas',
                type: 'bar',
                backgroundColor: '#F44336',
                stack: 'Stack 0',
                data: cashBookDashboard.cashOutflowValues
              }, 
              {
                label: 'Parcelas Recebidas',
                type: 'bar',
                backgroundColor: '#1976d2',
                stack: 'Stack 0',
                data: cashBookDashboard.cashInflowValues
              },
              {
                type: 'line',
                label: 'Saldo Projetado',
                borderColor: '#c3c3c3',
                borderWidth: 2,
                fill: false,
                data: cashBookDashboard.balancesExpected,
              },
              {
                label: 'Parcelas a Pagar',
                type: 'bar',
                backgroundColor: '#f3b2ae',
                stack: 'Stack 0',
                data: cashBookDashboard.cashOutflowExpected
              }, 
              {
                label: 'Parcelas a Receber',
                type: 'bar',
                backgroundColor: '#81a7ce',
                stack: 'Stack 0',
                data: cashBookDashboard.cashInflowExpected
              },
            ]
          }

          this.options = {
            maintainAspectRatio: false,
            title: {
              display: false,
              text: 'Chart.js Bar Chart - Stacked'
            },
            tooltips: {
              mode: 'point',
              intersect: true,
              callbacks: {
                label: function(tooltipItem, chart){
                  var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + " = " + numberToCurrency(tooltipItem.yLabel);
                },
                title: function(tooltipItem) {
                  // console.log(tooltipItem);
                  return "Dia " + tooltipItem[0].xLabel;
                }
              }
            },
            responsive: true,
            scales: {
              xAxes: [
                {
                  stacked: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Dia do Mês'
                  }
                }
              ],
              yAxes: [
                {
                  scaleLabel: {
                    display: false,
                    labelString: 'R$'
                  },
                  ticks: {
                    callback: function (value) {
                      // return numberToCurrency(value);
                      return numberToAbbrviatedCurrency(value);
                      // return (this.$vuetify.breakpoint.sm ? numberToAbbrviatedCurrency(value) : numberToCurrency(value))
                    }
                  }
                }
              ]
            },
            plugins: {
              legend: {
                  display: true,
                  labels: {
                      padding: 10
                  },
                  title: {
                    padding: 10
                  }
              }
            }
          }

          // console.log(aux);

          // this.$set(this.barChartData, 'labels', cashBookDashboard.chartLabels);
          // this.$set(this.barChartData, 'datasets', aux);
          

          this.cashBookDashboardLoading = false;
        })
        .catch(response => console.log(response));
    },
    updateMonthFilter: function() {
      // console.log("updateMonthFilter");
      if (this.type == 'month') { 
        this.calendarMonthFilter = this.calendar.substring(0, 7);
      } else {
        this.calendarMonthFilter = this.calendar;
      }
      this.calendarMonthFilterKey++;
    },
    changeCalendar: function(object) {
      // console.log("change calendar")
      if (this.type != 'day') {
        this.type = 'day';
        this.getEvents({});
      }
      this.updateMonthFilter();
    },
    changeCalendarType: function() {
      // console.log("changeCalendarType");
      if (this.type == 'month') {
        this.calendarMonthFilter = this.calendarMonthFilter.length > 7 ? this.calendarMonthFilter.substring(0, 7) : this.calendarMonthFilter;
      } else {
        this.calendarMonthFilter = this.calendarMonthFilter.length == 7 ? this.calendarMonthFilter + "-01" : this.calendarMonthFilter;
      }
      this.calendarMonthFilterKey++;
    },
    calendarMonthFilterChanged: function() {
      // console.log("calendarMonthFilterChanged");
      this.calendar = this.type == 'month' ? this.calendarMonthFilter + "-01" : this.calendarMonthFilter;
      // this.getEvents({});
    },
    getEvents ({ start, end }) {
      // console.log(start, end)
      let startDate = start ? start.date : this.startDate;
      let endDate = end ? end.date : this.endDate;
      this.startDate = startDate;
      this.endDate = endDate;
      // console.log(this.startDate, this.endDate);
      this.calendarLoading = true;
      this.$apollo
        .query({
          query: CALENDAR_QUERY,
          variables: {
            types: this.eventTypes,
            employeeIds: this.employeeIds,
            startDate: startDate,
            endDate: endDate
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // let cashBookDashboard = response.data.accountContext.cashBookDashboard;
          // this.cashBookDashboardLoading = false;
          this.events = response.data.accountContext.calendarAltavendaReport;
          console.log(this.events);
          this.employeesList = response.data.accountContext.allEmployees;
          // console.log(this.events);
          this.calendarLoading = false;
        })
        .catch(response => console.log(response));
    },
    getEventColor (event) {
      return event.color
    },
  }
}

function numberToCurrency(number, maxFractionDigits = 2) {
  return new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFractionDigits
  }).format(number);
}

function numberToAbbrviatedCurrency(number, maxFractionDigits = 2) {
  return new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
    notation: 'compact',
    compactDisplay: 'short'
  }).format(number);
}

const CASH_BOOK_DASHBOARD_QUERY = gql `
  query ($monthFilter: ISO8601Date!, $currentDate: ISO8601Date!){
    accountContext {
      cashBookDashboard(monthFilter: $monthFilter, currentDate: $currentDate) {
        chartLabels
        balances
        cashInflowValues
        cashOutflowValues
        balancesExpected
        cashInflowExpected
        cashOutflowExpected
      }
      financialIndicatorBankAccountBalance
      financialIndicatorStorageTotalBalance
      financialIndicatorPatrimoniesTotalPrice
      financialIndicatorOwnedAreasTotalPrice
    }
  }
`;

const CALENDAR_QUERY = gql `
query ($types: [String!], $employeeIds: [ID!], $startDate: ISO8601Date, $endDate: ISO8601Date) {
  accountContext {
    calendarAltavendaReport(types: $types, employeeIds: $employeeIds, startDate: $startDate, endDate: $endDate) 
    allEmployees {
      id
      name
    }
  }
}
`;

</script>

<style scoped>
  ::v-deep .v-calendar .v-event .v-icon, ::v-deep .v-calendar .v-event-timed .v-icon {
    color: white !important;
    font-size: 20px;
  }
</style>